//
//
//
//
//
//
//
//
//
//
//
//
//

import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

export default {
    name: 'SearchInput',
    data() {
        return {
            isShow: false,
        }
    },
    props: {
        debounce: {
            type: Number,
            default: 500,
        },
        value: String,
        title: String,
        list: Array,
        suggestions: Function,
        placeholder: String,
        select: Function,
        max: {
            type: Number,
            default: 1000,
        },
    },
    components: {
        Group,
        XInput,
    },
    mounted() {
        // 监听点击的是否是组件外的地方
        document.getElementsByTagName('body')[0].addEventListener('click', this.addEventListenerBody)
    },
    beforeDestroy() {
        document.getElementsByTagName('body')[0].removeEventListener('click', this.addEventListenerBody)
    },
    methods: {
        // 点击其他地方关闭下拉菜单
        addEventListenerBody(event) {
            if (this.isShow) {
                this.isShow = !this.isShow
            }
        },
        handleChange(newVal) {
            this.$emit('suggestions', newVal)
        },
        handleSelect(newVal) {
            this.$emit('select', newVal)
            this.isShow = false
        },
    },
    computed: {},
    watch: {
        list(newVal) {
            this.isShow = !!newVal.length
        },
    },
}
